import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../Pesado/actions'
import DialogView from '../../../Dialogos/DialogView'
import { COLORES } from '../../../../config/colores'
import { Button, Dialog, FormControlLabel } from '@material-ui/core'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_PESO_BRUTO } from '../../../../config/forms'
import CamposConfiguracionPesado from './CamposConfiguracionPesado'
import OpcionesConfiguracionPesado from './OpcionesConfiguracionPesado'
import SettingsIcon from '@material-ui/icons/Settings'
import BarreraBruto from '../bruto/BarreraBruto'

function ConfiguracionPesadoBruto (props) {
  const { equilibrio, roles, pesadoAuto, repesoBruto } = props
  const [open, setOpen] = useState(false)
  const [repeso, setRepeso] = useState(false)
  // const [viewPedidos, setViewPedidos] = useState(false)
  const [textPesadoEnCabina, setTextPesadoEnCabina] = useState('Pesando en panel externo')

  const previousRepesoBrutoRef = useRef(null)

  useEffect(() => {
    if (previousRepesoBrutoRef.current !== repesoBruto) {
      setRepeso(repesoBruto)
      previousRepesoBrutoRef.current = repesoBruto
    }
  }, [repesoBruto])

  const updateModoPesado = () => {
    const { balanza } = props
    if (pesadoAuto) {
      props.updateModoPesajeBruto('manual', balanza)
    } else {
      props.updateModoPesajeBruto('auto', balanza)
    }
  }

  const updateEnclavamiento = () => {
    const { equilibrio } = props
    if (equilibrio) {
      props.updateEnclavamientoBruto(0)
    } else {
      props.updateEnclavamientoBruto(1)
    }
  // props.queryParametrosBruto()
  }

  const updatePedidoDeConfirmacion = () => {
    const { pedirConfirmacion } = props
    if (pedirConfirmacion === 1) {
      props.updatePedidoDeConfirmacionBruto(0)
    } else {
      props.updatePedidoDeConfirmacionBruto(1)
    }
  }

  const updatePesoSinEgresoCalado = () => {
    const { sinEgresoCalado } = props
    if (sinEgresoCalado === 1) {
      props.updatePesoSinEgresoDeCalado(0)
    } else {
      props.updatePesoSinEgresoDeCalado(1)
    }
  }

  const setPesadoCabina = () => {
    if (textPesadoEnCabina === 'Pesando en cabina') {
      setTextPesadoEnCabina('Pesando en panel externo')
    } else {
      setTextPesadoEnCabina('Pesando en cabina')
    }
    props.pesadoEnCabina()
  }

  const openDialogConfiguracion = () => {
    const { change: formChange, urlBruto, pesoMaximo, pesoMaximoAdvertencia, pesoMinimo, pesoMinimoAdvertencia, dialogOpen } = props
    dialogOpen(true)
    formChange('urlBruto', urlBruto && urlBruto)
    formChange('pesoMaximo', pesoMaximo && pesoMaximo)
    formChange('pesoMaximoAdvertencia', pesoMaximoAdvertencia && pesoMaximoAdvertencia)
    formChange('pesoMinimo', pesoMinimo && pesoMinimo)
    formChange('pesoMinimoAdvertencia', pesoMinimoAdvertencia && pesoMinimoAdvertencia)
    setOpen(true)
  }

  const updateRepeso = () => {
    setRepeso(!repeso)
    props.updateRepeso()
    props.queryParametrosBruto()
  }

  const closeDialog = () => {
    setOpen(false)
    props.dialogOpen(false)
  }

  // const setMotivoActividadBarrera = (motivo) => {
  //   const { change: formChange } = props
  //   formChange('motivoActBarrera', motivo)
  // }

  const updateParametros = () => {
    const { url, pMax, pMaxAdvertencia, pMin, pMinAdvertencia } = props
    props.updateUrlBruto(url)
    props.updatePesoMaximoBruto(parseInt(pMax))
    props.updatePesoMaximoAdvertenciaBruto(parseInt(pMaxAdvertencia))
    props.updatePesoMinimoBruto(parseInt(pMin))
    props.updatePesoMinimoAdvertenciaBruto(parseInt(pMinAdvertencia))
    setOpen(false)
    props.queryParametrosBruto()
  }

  const rol = roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  const updateBalanzaDeBruto = () => {
    const { balanza } = props
    if (balanza === 'BRUTO') {
      props.setBalanzaDeBruto('MULETO', 0)
    } else {
      props.setBalanzaDeBruto('BRUTO', 1)
    }
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={closeDialog}
        aria-labelledby='form-dialog-title'
      >
        <DialogView
          confirmCallback={updateParametros}
          cancelCallback={closeDialog}
          title='Configuración de parámetros de bruto'
          content={
            <CamposConfiguracionPesado
              rolAutorizado={rolAutorizado}
              balanza={props.balanza}
              updateBalanzaDeBruto={updateBalanzaDeBruto}

            />
          }
        />
      </Dialog>

      {/* <Dialog
        open={viewPedidos}
        onClose={closeDialogPedidos}
        aria-labelledby='form-dialog-title'
      /> */}

      <div className='container-switches-bruto'>
        <OpcionesConfiguracionPesado
          updateEnclavamiento={updateEnclavamiento}
          updateModoPesado={updateModoPesado}
          updatePesoSinEgresoCalado={updatePesoSinEgresoCalado}
          updatePedidoDeConfirmacion={updatePedidoDeConfirmacion}
          equilibrio={equilibrio}
          pesadoAuto={pesadoAuto}
          tipoPesado={props.tipoPesado}
          sinEgresoCalado={props.sinEgresoCalado}
          pedirConfirmacion={props.pedirConfirmacion}
          rolAutorizado={rolAutorizado}
          enclavamientoBarreras={props.enclavamientoBarreras}
          updateEnclavamientoBarreras={props.updateEnclavamientoBarreras}
        />

        <div className='contenedor-acciones-bruto'>

          { pesadoAuto && !props.cpe && <Button
            variant='contained'
            color='primary'
            onClick={setPesadoCabina}
          >
            {textPesadoEnCabina}
          </Button>
          }

          <BarreraBruto
            setMotivo={props.setMotivoActividadBarrera}
            dialogOpen={props.dialogOpen}
          />

          <FormControlLabel
            style={{ margin: 0, width: '100%' }}
            control={<Button
              variant='contained'
              disabled={!rolAutorizado}
              color='primary'
              onClick={updateRepeso}
              style={{ backgroundColor: repeso ? COLORES.success : COLORES.blue.primary, width: '100%' }}
            >
                Repeso
            </Button>
            }
          />

          {/* TODO: desarrollar pedidos a calado desde bruto */}
          {/* <Button
            variant='contained'
            style={{ backgroundColor: COLORES.grey.dark, color: '#ffffff' }}
            onClick={openDialogPedidos}
          >
            Pedidos a calado
          </Button> */}

          {/* <div>

            <Dialog fullScreen open={this.state.viewPedidos} onClose={this.handleClosePedidos} TransitionComponent={Transition} >
              <Toolbar style={{ display: 'flex', justifiContent: 'space-between', backgroundColor: '#3f51b5' }} >
                <IconButton edge='start' style={{ color: '#ffffff' }} onClick={this.handleClosePedidos} aria-label='close'>
                  <CloseIcon />
                </IconButton>
              <Typography variant='h6' style={{ color: '#ffffff' }} >
                    Pedidos a calado
                </Typography>
            </Toolbar>
                    <PedidosCalado />
          </Dialog>
          </div> */}
        </div>

        { rolAutorizado && <Button
          variant='contained'
          style={{ color: COLORES.blue.primary, width: '100%', fontWeight: 'bold', marginTop: '3%' }}
          size='small'
          onClick={() => { openDialogConfiguracion() }}
        >
          <SettingsIcon style={{ color: COLORES.grey.light }} />
                              Más configuraciones
        </Button>
        }

      </div>

    </>
  )
}

const selector = formValueSelector(FORM_PESO_BRUTO)

const mapStateToProps = (state) => ({
  balanza: state.pesado.balanzaBruto,
  cpe: state.pesado.cpePesadoBruto,
  pesaje: state.pesado.pesajeBruto,
  equilibrio: state.pesado.equilibrioBruto,
  urlBruto: state.pesado.urlBruto,
  url: selector(state, 'urlBruto'),
  pedirConfirmacion: state.pesado.pedirConfirmacion,
  pesoMaximo: state.pesado.pesoMaximo,
  pMax: selector(state, 'pesoMaximo'),
  pesoMaximoAdvertencia: state.pesado.pesoMaximoAdvertencia,
  pMaxAdvertencia: selector(state, 'pesoMaximoAdvertencia'),
  pesoMinimo: state.pesado.pesoMinimo,
  pMin: selector(state, 'pesoMinimo'),
  pesoMinimoAdvertencia: state.pesado.pesoMinimoAdvertencia,
  pMinAdvertencia: selector(state, 'pesoMinimoAdvertencia'),
  roles: state.auth.roles,
  repesoBruto: selector(state, 'repesoBruto'),
  sinEgresoCalado: state.pesado.brutoSinEgresoCalado,
  motivoActBarrera: selector(state, 'motivoActBarrera')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_BRUTO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})

export default withRedux(withReduxForm(ConfiguracionPesadoBruto))
